<template>
  <v-row no-gutters class="pa-10">
    <v-col cols="12">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row class="pb-2">
          <v-col cols="12" class="py-2">
            <v-text-field
              color="primaryDark"
              dense
              v-model="new_connection.properties"
              label="Number of Properties"
              :counter="50"
              :rules="numberRule([1, 20], true)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-radio-group :rules="requiredRule" label="Phase Type" dense row v-model="new_connection.phase_type">
              <v-radio v-for="ph in phases" :key="ph" :label="ph" :value="ph"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-radio-group :rules="requiredRule" label="Heating Type" dense row v-model="new_connection.heating_type">
              <v-radio v-for="ph in heating_type" :key="ph" :label="ph" :value="ph"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-text-field
              color="primaryDark"
              dense
              v-model="new_connection.heat_pump_input"
              label="Heat pump input (kW)"
              :rules="numberRule([1, 20], false)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-radio-group :rules="requiredRule" label="Backup Heating" dense row v-model="new_connection.heating">
              <v-radio v-for="ph in heating" :key="ph" :label="ph" :value="ph"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-radio-group
              :rules="requiredRule"
              label="Electric Cooker"
              dense
              row
              v-model="new_connection.electric_cooker"
            >
              <v-radio v-for="ph in multi_choice" :key="ph" :label="ph" :value="ph"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-radio-group
              :rules="requiredRule"
              label="Electric Shower"
              dense
              row
              v-model="new_connection.electric_shower"
            >
              <v-radio v-for="ph in multi_choice" :key="ph" :label="ph" :value="ph"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-text-field
              color="primaryDark"
              dense
              v-model="new_connection.other_load"
              :rules="numberRule([1, 500], false)"
              label="Other significant load (kW): "
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-radio-group
              :rules="requiredRule"
              label="EV charging points per connection"
              dense
              row
              v-model="new_connection.ev_con"
            >
              <v-radio v-for="ph in multi_choice" :key="ph" :label="ph" :value="ph"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-text-field
              v-if="new_connection.ev_con == 'Yes'"
              color="primaryDark"
              dense
              v-model="new_connection.ev_chargers"
              :rules="numberRule([1, 5], true)"
              label="EV number of chargers"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-2">
            <v-text-field
              color="primaryDark"
              v-if="new_connection.ev_con == 'Yes'"
              dense
              v-model="new_connection.ev_avg_load"
              :rules="numberRule([0, 50], false)"
              label="EV average load per charger (kW)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn
              dense
              color="secondary"
              @click="validate('estimateCost', new_connection)"
              class="bold"
              :disabled="!valid"
              >Proceed</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { content } from "../../config/config.js";

export default {
  name: "NewConDetails",
  props: {},
  watch: {},
  data: function () {
    return {
      valid: true,
      page_content: null,
      maxAndRequiredRule: [
        (v) => !!v || "This field is required",
        (v) => (v && v.length <= 50) || "Must be less than 50 characters",
      ],
      requiredRule: [(v) => !!v || "This field is required"],
      date_picker: false,
      phases: ["Single", "Split", "Three-phase"],
      heating_type: ["Gas", "Electric Resistance", "Heat Pump"],
      heating: ["Electric", "None"],
      multi_choice: ["Yes", "No"],
      new_connection: {},
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {},
  methods: {
    maxRule: function (characters, isRequired) {
      return isRequired
        ? [
            (v) => !!v || "This field is required",
            (v) => (v && v.length <= characters) || `Must be less than ${characters} characters`,
          ]
        : [(v) => !v || (v && v.length <= characters) || `Must be less than ${characters} characters`];
    },

    numberRule: function (digits, isRequired) {
      if (typeof digits == "number") {
        return isRequired
          ? [(v) => !!v || "This field is required", (v) => (v && v <= digits) || `Must be less than ${digits}`]
          : [(v) => !v || (v && v <= digits) || `Must be less than ${digits}`];
      } else {
        return isRequired
          ? [
              (v) => !!v || "This field is required",
              (v) =>
                (v && v <= digits[1] && v >= digits[0]) ||
                `Must be less than ${digits[1]} and greater than ${digits[0]}`,
            ]
          : [(v) => !v || (v && v <= digits[1] && v >= digits[0]) || `Must be less than ${digits}`];
      }
    },
    validate: function (event, obj) {
      if (this.$refs.form.validate()) {
        this.$emit(event, obj);
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.opaque {
  opacity: 0.7;
}

.theme--light.v-input input {
  color: var(--v-vtred-base) !important;
}

.v-input--radio-group {
  margin-top: 0;
  padding-top: 0;
}
</style>
